export const COMMUNITY_COLLECTION = 'community';
export const LISTINGS_COLLECTION = 'listings';
export const USERS_COLLECTION = 'users';
export const EMAIL_COLLECTION = 'mail';